import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  urlApi = environment.urlApiVideos.url;
  backUrl = environment.urlApiVideos.backAuthurl;
  headers: HttpHeaders
  basic: string

  constructor(private http: HttpClient) {
    this.createBtoaLogin();
  }

  createBtoaLogin(): void {
    this.basic = btoa(environment.urlApiVideos.user+':'+environment.urlApiVideos.password)
  }

  obtenerModulosPorUsuario(userId: string): Observable<any[]> {
    let patch = `/api/Portal/Profile/ProfilePermissionsByUser?UserId=${userId}`
    return this.http.get<{UserProfiles:any[]}>(
      this.urlApi + patch,
      {
        headers: new HttpHeaders().set('Authorization', "Basic "+ this.basic)
      }).pipe(
        map(response => response.UserProfiles)
      );
  }

  validarTokenYUserId(token:string, userId:string): Observable<Boolean>{
    let patch = `/api/Auth/validateToken`
    let body = {
      "UserId": userId,
      "Token": token
    }
    return this.http.post<any>(
      this.backUrl + patch,
      body).pipe(
        map(response => response.objectResponse.code == "True")
      );
  }

}


